const validator = {
  getMesage() {
    return "deve conter pelo menos 6 caracteres entre letras e númerosA senha deve conter letras e números.";
  },

  validate(value) {
    if (value.length > 6) {
      var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[0-9])");
      return strongRegex.test(value);
    }
  }
};
export default validator;
